<template>
  <div class="clientilist">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Lista Macchine</h5>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button variant="success" style="float: right" to="/macchine/aggiungi"><font-awesome-icon icon="plus-circle" /> Aggiungi Macchina</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="lista"
            :fields="campi"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="action" slot-scope="row">
              <b-button size="sm" variant="danger" v-on:click="openModalDeleteMacchina(row.item)"><font-awesome-icon icon="trash-alt" /></b-button>
              <b-button size="sm" style="margin-left: 10px;" :to="'macchine/modifica/'+row.item.id"><font-awesome-icon icon="edit" /></b-button>
              <b-button size="sm" variant="success" style="margin-left: 10px;" :to="'macchine/pacchetti/'+row.item.id"><font-awesome-icon icon="file-archive" /></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="modal.delete" title="Conferma richiesta di eliminazione!">
      <p>Sei sicuro di voler eliminare <strong>{{modalData.delete.nome}} {{modalData.delete.cognome}}</strong>?</p>
      <div slot="modal-footer">
        <b-button class="float-right" variant="danger" style="margin-left: 10px" v-on:click="deleteMacchina(modalData.delete.id)">Si</b-button>
        <b-button class="float-right" v-on:click="modal.delete = false">No</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'clientiadd',
  data() {
    return {
      lista: [],
      campi: [
        {key: 'tipologia', label: 'Tipologia', sortable: true},
        {key: 'codprodotto', label: 'Numero di Matricola', sortable: true},
        {key: 'descrizione', label: 'Descrizione', sortable: true},
        {key: 'cliente', label: 'Cliente', sortable: true},
        {key: 'ubicazione', label: 'Ubicazione', sortable: true},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      modal: {
        delete: false
      },
      modalData: {
        delete: {}
      }
    }
  },
  created: function(){
    this.getListaMacchine()
  },
  methods: {
    getListaMacchine(){
      Vue.http.post('macchina/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.lista = response.body.data.map(e => {
              var x = e.ubicazione.split(",")
              console.log(x[x.length-1].trim().slice(0, 2))
              if(x[x.length-1].trim().slice(0, 2) == "M_")
                e.ubicazione = x.slice(0, x.length-1).join(", ")+", "+x[x.length-1].trim().slice(2)

              return e
            })
            
            this.totalRows = this.lista.length
        }else{
          this.lista = []
            /*Vue.notify({
                group: 'global',
                title: 'Errore',
                text: "Lista installatori non caricata correttamente.",
                type: 'error'
            })*/
        }
      }, response => {})
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openModalDeleteMacchina(item){
      this.modalData.delete = item
      this.modal.delete = true
    },
    deleteMacchina(id){
      Vue.http.post('macchina/delete/'+id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.getListaMacchine()
          
          this.modal.delete = false
          this.modalData.delete = {}

          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita!',
              text: "Macchina eliminata correttamente.",
              type: 'success'
          })
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    }
  }
}
</script>


<style>
</style>